// ToastTest.js
import React from "react";
import { Button } from "@chakra-ui/react";
import { createStandaloneToast } from "@chakra-ui/react";

function ToastTest() {
const { toast } = createStandaloneToast();

return (
<Button
colorScheme="teal"
onClick={() =>
toast({
title: "Success!",
description: "This is a Chakra toast",
status: "success",
duration: 3000,
isClosable: true,
})
}
>
Show Toast
</Button>
);
}

export default ToastTest;